
import { ResultData } from "@nt-portal/common-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { DbInuseResult, TCMResponseStatus, TCMResponseStatusService } from "@nt-portal/tcm-sdk";
import { ValidateResult } from "@nt-portal/common-sdk";

export interface TCMResponseStatusOptions extends ControllerOptions<TCMResponseStatus> {

}


export const initTCMResponseStatus = (inObj: Partial<TCMResponseStatus>): TCMResponseStatus => {
    let item: TCMResponseStatus = {
        color: inObj.color ?? "000000",
        description: inObj.description ?? "",
        name: inObj.name ?? "",
        value: inObj.value ?? "",
        createdBy: ""
    }
    return item;
}


export class ClientTCMResponseStatusService extends BaseClientService implements DataController<TCMResponseStatus> {

    private _service: TCMResponseStatusService;


    constructor() {
        super();
        this._service = new TCMResponseStatusService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public async get(options: TCMResponseStatusOptions): Promise<ResultData<TCMResponseStatus>> {

        return await this._service.get(this.buildFetchParams(options), this.token, options.filter);

    }
    public async getLookup(options: TCMResponseStatusOptions): Promise<ResultData<TCMResponseStatus>> {
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token);
        return data;
    }

    public async getById(options: TCMResponseStatusOptions): Promise<TCMResponseStatus | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMResponseStatusOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: TCMResponseStatusOptions): Promise<TCMResponseStatus | TCMResponseStatus[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: TCMResponseStatusOptions): Promise<TCMResponseStatus | TCMResponseStatus[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }

    public async inUse(options: TCMResponseStatusOptions): Promise<DbInuseResult[]> {
        if (options.id) {
            return await this._service.inUse(options.id, this.token);
        }
        throw new Error("ID is required for inUse check");
    }

    public async validateName(name: string, id?: string): Promise<ValidateResult> {
        return await this._service.validateName(name, this.token, id)
    }

    public async import(options: TCMResponseStatusOptions): Promise<any> {
        if (options.file)
            return await this._service.importExcel(options.file, this.token);
    }

    public async export(options: TCMResponseStatusOptions): Promise<any> {
        let fetchParams = this.buildLookupFetchParams(options);
        return await this._service.export(this.token, fetchParams, options.filter);
    }

}
